module.exports = __webpack_public_path__ + "assets/img/Type E (23).124cbb4b.jpg";